<script>
const approveNum = 0;
export default
  {
    approveNum,//审核代办数量
  }
</script>